export default function() {
    (function($) {
        $(function() {
            let news_page_count = 2;
            $('.more-news-local').click(function() {
                $('.more-news-local').text("Loading...");
                $.get( "/wp-json/wp/v2/news/?&per_page=3&page=" + news_page_count, function( data ) {
                    if (data.length) {
                            let resultsHtml = [];
                            data.forEach(function(dataItem) {
                                var img;
                                var img;
                                var d = new Date(dataItem.date);
                                console.log(d.toLocaleDateString('en'));
                                var newDate = d.toString().split(" ").slice(1, 4).join(" ");
                                //console.log(newDate.toLocaleString('en'));
                                if (dataItem.acf.has_main_image == true) {
                                    img = dataItem.acf.main_image.url;
                                } else {
                                    $.get( "/wp-json/wp/v2/pages/94", function ( data ) {
                                        img = data.acf.hero_image.link;
                                    });
                                }
                                const str = dataItem.content.rendered.split(" ");
                                let excerpt = [];
                                for (let i = 0; i < 15; i++) {
                                    excerpt.push(str[i]);
                                }
                                const entryHtml = `
                                <div class="card-item">
                                <article class="mg-card-fixed md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg">
                                        <img class='card-image' src="${img}">
                                        <p class="my-2">
                                                <span
                                                        class="my-2 heading-font text-sm uppercase font-normal mg-color-secondary-lighter">
                                                        ${newDate}
                                                </span><br />
                                                <br />
                                                <a href="${dataItem.link}">${dataItem.title.rendered}</a>
                                                <br />
                                                <div> ${ excerpt.join(" ") }... <a href='${dataItem.link}'> Read More » </a> </div>
                        </div>`;
                                resultsHtml.push(entryHtml);
                                $('.more-news-local').text("More News");
                                news_page_count++;  
                            });
                            $('.news-list-local').hide().append(resultsHtml).fadeIn();

        }
        }).fail(function() {
            $('.more-news-local').text("No more to load");
        });
    });
});
        $(function() {
            let news_page_count = 2;
            $('.more-news').click(function() {
                $('.more-news').text("Loading...");
                $.get( "https://grains.org/wp-json/wp/v2/posts/?filter[category_name]=council-news&per_page=3&page=" + news_page_count, function( data ) {
                    if (data.length) {
                        let resultsHtml = [];
                        data.forEach(function(dataItem) {
                            var img;
                            var d = new Date(dataItem.date);
                            var newDate = d.toString().split(" ").slice(1, 4).join(" ");
                            if (dataItem.acf.has_main_image == true) {
                                img = dataItem.acf.main_image.url;
                            } else {
                                $.get( "/wp-json/wp/v2/pages/94", function ( data ) {
                                    img = data.acf.hero_image.link;
                                });
                            }
                            const str = dataItem.content.rendered.split(" ");
                            let excerpt = [];
                            for (let i = 0; i < 15; i++) {
                                excerpt.push(str[i]);
                              }
                            const entryHtml = `
                            <div class="card-item">
                            <article class="mg-card-fixed md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg">
                                    <img class='card-image' src="${img}">
                                    <p class="my-2">
                                            <span
                                                    class="my-2 heading-font text-sm uppercase font-normal mg-color-secondary-lighter">
                                                    ${newDate}
                                            </span><br />
                                            <br />
                                            <a href="${dataItem.link}">${dataItem.title.rendered}</a>
                                            <br />
                                            <div> ${ excerpt.join(" ") }... <a href='${dataItem.link}'> Read More» </a> </div>
                    </div>`;
                            resultsHtml.push(entryHtml);
                            $('.more-news').text("More News");
                            news_page_count++;  
                        });
                        $('.news-list').hide().append(resultsHtml).fadeIn();
            }
        }).fail(function() {
            $('.more-news-local').text("No more to load");
        });;
    });
});
$(function() {
    let news_page_count = 2;
    $('.more-success').click(function() {
        $('.more-success').text("Loading...");
        $.get( "https://grains.org/wp-json/wp/v2/success_story/?&per_page=3&page=" + news_page_count, function( data ) {
            if (data.length) {
                let resultsHtml = [];
                data.forEach(function(dataItem) {
                    var img;
                    var d = new Date(dataItem.date);
                    var newDate = d.toString().split(" ").slice(1, 4).join(" ");
                    if (dataItem.acf.has_main_image == true) {
                        img = dataItem.acf.main_image.url;
                    } else {
                        $.get( "/wp-json/wp/v2/pages/94", function ( data ) {
                            img = data.acf.hero_image.link;
                        });
                    }
                    const str = dataItem.content.rendered.split(" ");
                    let excerpt = [];
                    for (let i = 0; i < 15; i++) {
                        excerpt.push(str[i]);
                      }
                    const entryHtml = `
                    <div class="card-item">
                    <article class="mg-card-fixed md:max-w-sm overflow-hidden shadow-lg border-t-8 mg-border-accent-lighter p-8 pb-0 hentry bg-white rounded-lg">
                            <img class='card-image' src="${img}">
                            <p class="my-2">
                                    <span
                                            class="my-2 heading-font text-sm uppercase font-normal mg-color-secondary-lighter">
                                            ${newDate}
                                    </span><br />
                                    <br />
                                    <a href="${dataItem.link}">${dataItem.title.rendered}</a>
                                    <br />
                                    <div> ${ excerpt.join(" ") }... <a href='${dataItem.link}'> Read More » </a> </div>
            </div>`;
                    resultsHtml.push(entryHtml);
                    $('.more-success').text("More Success Stories");
                    news_page_count++;  
                });
                $('.success-list').hide().append(resultsHtml).fadeIn();
    }
}).fail(function() {
    $('.more-news-local').text("No more to load");
});;
});
});

    })(jQuery);
}




// WEBPACK FOOTER //
// ./src/js/partials/more-news.js